/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Agent } from '../../models/agent';

export interface GetAgent$Params {
  agent_id: string;
}

export function getAgent(http: HttpClient, rootUrl: string, params: GetAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<Agent>> {
  const rb = new RequestBuilder(rootUrl, getAgent.PATH, 'get');
  if (params) {
    rb.path('agent_id', params.agent_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Agent>;
    })
  );
}

getAgent.PATH = '/agents/{agent_id}';
